export class SmsAccount {
  apiKey;
  apiType;
  clientId;
  description;
  id;
  name;
  secret;
  constructor(obj?: SmsAccount) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/sms-accounts/sms-account.model.ts